<template>
  <div>
    <el-col class="banner">
      <el-carousel :interval="2000" arrow="always">
        <el-carousel-item v-for="(item,index) in banners" :key="index">
          <a :href="item.link">
          <img :src="item.imgpath" class="lunbotu" :alt="item.imgpath" />
          </a>
        </el-carousel-item>
      </el-carousel>
    </el-col>
  </div>
</template>
<script>
var that;

export default {
  data() {
    return {
      banners: []
    };
  },
  mounted() {
    that = this;
    that.init();
  },
  methods: {
    init() {
      $.ajax({
        type: "get",
        url: url + "/banners",
        success: function(data) {
          if (data.code == "0") {
            that.banners = data.data;
            console.log(data)
          }
        },
        error(data) {
          // alert(data.msg);
        }
      });
    }
  }
};
</script>
<style scoped>
.banner {
  width: 100%;
  margin: 0 auto;
  min-width: 1200px;
}
.el-carousel__container {
  width: 1200px;
}
.el-carousel--horizontal {
  width: 1200px;
  margin: 0 auto;
}
.el-carousel__item img {
  width: 1200px;
}

@media only screen and (max-width: 1024px) {
  .el-col-18 {
    width: 96% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/com/rotation.vue